module.exports = __webpack_public_path__ + "img/hy3.00caa5eb.png";